var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"file","accept":_vm.audioFileAllowedExtensions.join(',')},on:{"change":function($event){$event.preventDefault();return _vm.onChange($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }